module.exports = __webpack_public_path__ + "7340168757dd28f2e376696e52a78c48.pdf";